import { useSyncExternalStore } from 'react';

import uppyManager from '../Uploader/uppyManager';

// Hook that checks whether any upload is currently in progress, used to prevent session expiry during active uploads.
const usePreventSessionExpiry = () => {
    const subscribe = uppyManager.subscribeToProgress;
    const getSnapshot = uppyManager.getProgressSnapshot;

    const progress = useSyncExternalStore(subscribe, getSnapshot);

    return (
        progress.uploading > 0 ||
        progress.pending > 0 ||
        progress.processing > 0
    );
};

export default usePreventSessionExpiry;
